<template>
  <div id="jumbotron">
    <div class="container">
      <h1>Cambridge<br>English Exams</h1>
    </div>
  </div>

  <div class="container my-5">
    <div class="row flex-row-reverse m-0">
      <div class="col-12 col-md-6">
        <div id="exam" class="mx-auto py-md-5 mt-md-5 mb-5">
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/cambridge-exams-ielts.webp" alt="Cambridge English Exams" width="400px" class="w-100">
        </div>
      </div>
      <div class="col-12 col-md-6">
        <h2 class="text-primary">
          Approach To English Exams and Learning
        </h2>

        <p>
          We have a 100% pass rate for the Cambridge English exams – FCE, CAE & CPE.   
        </p>

        <p>
          These exams are internationally recognised and accepted by thousands of schools, universities and employers worldwide.
        </p>

        <p>
          However, we recognise that Malaysian children already have a lot of school exams to worry about – and so the main focus of our English language classes, especially with our younger learners, is not on external exams but to promote fluency and accuracy in all areas of the English language.
        </p>

        <p>
          As our students progress, they will be able to apply their English language skills to all areas of their lives, including their school work and, later, their further studies and in their chosen professions.
        </p>

        <p>
          For us, learning English is more than just exams and grades. It’s about having the confidence to communicate and access a lifetime of enriching experiences and opportunities. Our qualifications are designed specifically for school-aged students, giving them regular milestones to keep them motivated.
        </p>
      </div>
    </div>
  </div>

  <ContactUs />
</template>

<script>
import ContactUs from '../components/ContactUs.vue';
export default {
  components: { ContactUs }
}
</script>

<style scoped>
#jumbotron {
  background-color: #2e1aaf;
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/celebration.png");
  background-size: cover;
  background-position: right bottom -200px;
  background-repeat: no-repeat;
  padding-top: 20vh;
  color: white;
  height: 55vh;
}

.container { max-width: 1100px; }
#exam { max-width: 400px; }

h1 { font-size: 3.5em; }
h2 { font-size: 3em; }
</style>